import type { WhitelabelConfig } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { whitelabelKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function getWhitelabelConfig(id: string): Promise<WhitelabelConfig> {
  return apiClient.url(`/whitelabel/configs/${id}`).get().json();
}

export function useGetWhitelabelConfig(
  id: string,
): UseQueryResult<WhitelabelConfig, Error> {
  return useQuery({
    enabled: !!id,
    queryFn: () => getWhitelabelConfig(id),
    queryKey: whitelabelKeys.detail(id),
  });
}
